module.exports = __webpack_public_path__ + "static/media/icon-benchmark.726c78d5.svg";